import { render, staticRenderFns } from "./ScheduledGathering.vue?vue&type=template&id=3196788c&scoped=true&"
import script from "./ScheduledGathering.vue?vue&type=script&lang=js&"
export * from "./ScheduledGathering.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledGathering.vue?vue&type=style&index=0&id=3196788c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196788c",
  null
  
)

export default component.exports